import { createStylesParams } from '@wix/tpa-settings';

import {
  fulfillmentPickerStylesParams as sharedFulfillmentPickerStylesParams,
  type FulfillmentPickerStylesParams as SharedFulfillmentPickerStylesParams,
} from '../../../../../../components-shared/FulfillmentPicker/stylesParams';
import {
  dispatchInfoStylesParams,
  type DispatchInfoStylesParams,
} from '../DispatchInfo/stylesParams';

export {
  fulfillmentPickerStylesParams,
  type FulfillmentPickerStylesParams,
} from '../../../../../../components-shared/FulfillmentPicker/stylesParams';

export type FulfillmentSectionStylesParams =
  SharedFulfillmentPickerStylesParams & DispatchInfoStylesParams;

export const fulfillmentSectionStylesParams =
  createStylesParams<FulfillmentSectionStylesParams>({
    ...sharedFulfillmentPickerStylesParams,
    ...dispatchInfoStylesParams,
  });
